export default {
  applyFilter: {
    id: 'LIST_VISOR_FILTER_PILL_APPLY',
    description: 'filter modal button label for applying a filter selection.',
    defaultMessage: 'Apply Filter',
  },
};
